import { useMutation } from 'react-query'
import axios from 'axios'
import { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { baseUrl } from '.'

const wizardApiUrl = process.env.REACT_APP_WIZARD_TRAVEL_API
const url = `${baseUrl}/${wizardApiUrl}`

export const useAddVariant = (paramsId: string) =>
    useMutation((data: InsuranceParamsTravelDto) =>
        axios.post(`${url}/AddVariant?paramsId=${paramsId}`, data))